import './breadcrumbs.scss';
import './img/arrow_breadcrumbs.png';


// WEBPACK FOOTER //
// ./resources/views/partials/archive/breadcrumbs/breadcrumbs.js